import React from 'react';
import {faSearchLocation, faMobileAlt, faEnvelope} from '@fortawesome/free-solid-svg-icons'

import map from '../../../images/ValleyWorxMap.png';
import { 
    StyledContainer, 
    StyledGrid, 
    StyledGridItem, 
    StyledH2, 
    StyledImg, 
    StyledIcon,
    StyledP, 
    StyledSpan, 
} from './Location.style';

const Location = () => {
    return(
        <StyledContainer id='location'>
            <StyledGrid container spacing={3}>
                <StyledGridItem item md={4} sm={12}>
                    <StyledH2>Our Location</StyledH2>
                    <StyledP>
                        If you're ready to launch your innovative idea 
                        or transform an existing project, drop us a line.
                    </StyledP>
                    <br />
                    <StyledP>
                        <StyledIcon icon={faSearchLocation} aria-hidden="true"/>
                        4701 Stoddard Rd, Modesto, CA 95356
                    </StyledP>
                    <br />
                    <StyledP>
                        <StyledIcon icon={faMobileAlt} aria-hidden="true"/> 209 322 7884
                    </StyledP>
                    <br />
                    <StyledP>
                        <StyledIcon icon={faEnvelope} aria-hidden="true"/> <StyledSpan>contact@taylorlamar.com</StyledSpan>
                    </StyledP>
                </StyledGridItem>
                <StyledGridItem image='true' item md={8} sm={12}>
                    <StyledImg src={map} alt='map of modesto'/>
                </StyledGridItem>
            </StyledGrid>
        </StyledContainer>
    )
}

export default Location;
